export const DEFAULT_AVATAR =
  "https://st4.depositphotos.com/4329009/19956/v/450/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg";

export const ROLES = [
  { id: "all", label: "هەمووی" },
  { id: "admin", label: "ئەدمین" },
  { id: "lab", label: "تاقیگە" },
  { id: "application", label: "ئەپپڵیکەیشن" },
  { id: "note", label: "تێبینی" },
  { id: "Secretary", label: "سکرتێر" },
];

export const ROLE_LABELS = {
  admin: "ئەدمین",
  lab: "تاقیگە",
  application: "ئەپپڵیکەیشن",
  note: "تێبینی",
  Secretary: "سکرتێر",
};

export const ROLE_COLORS = {
  admin: "#006d77",
  lab: "#2a9d8f",
  application: "#264653",
  note: "#3d5a80",
  Secretary: "#6d597a",
};

export function initials(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "ک";
  return parts.slice(0, 2).map((part) => part[0]).join("");
}

export function dummyRequest({ onSuccess }) {
  setTimeout(() => onSuccess("ok"), 0);
}
